<template>
  <div class="course_index" id="course_home">
    <div class="header">
      <div>
        <img src="@/img/logo_course.png" height="30" alt />
      </div>
      <div>
        <div>
          <img src="@/img/touxiang.png" alt />
          <span>{{ user.xm }}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container_left">
        <div class="card1">
          <el-tabs v-model="active1" @tab-click="tab1Active1 = 1">
            <el-tab-pane :label="`${year}年课题研究时间表`" name="1">
              <div class="tab1_active1">
                <div class="tab1_active1_left">
                  <div
                    :class="tab1Active1 == 1 ? 'tab1_active1_div' : ''"
                    @click="tab1Active1 = 1"
                  >
                    研究课题
                  </div>
                  <div
                    :class="tab1Active1 == 2 ? 'tab1_active1_div' : ''"
                    @click="tab1Active1 = 2"
                  >
                    技术课题
                  </div>
                </div>
                <div class="tab1_active1_right">
                  <el-table
                    :max-height="400"
                    :data="tab1TableYJ"
                    fit
                    highlight-current-row
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    tooltip-effect="dark"
                    v-if="tab1Active1 == 1"
                  >
                    <el-table-column
                      label="阶段名称"
                      align="left"
                      prop="step_name"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="开始时间"
                      align="left"
                      prop="starttime"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="结束时间"
                      align="left"
                      prop="endtime"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="关键物"
                      align="left"
                      prop="gjw"
                      min-width="250px"
                      :show-overflow-tooltip="true"
                    />
                    <template slot="empty">
                      <div class="nodata">
                        <img src="@/img/nodata.png" alt="" width="160" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </el-table>
                  <el-table
                    :max-height="400"
                    :data="tab1TableJs"
                    fit
                    highlight-current-row
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    tooltip-effect="dark"
                    v-if="tab1Active1 == 2"
                  >
                    <el-table-column
                      label="阶段名称"
                      align="left"
                      prop="step_name"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="开始时间"
                      align="left"
                      prop="starttime"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="结束时间"
                      align="left"
                      prop="endtime"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="关键物"
                      align="left"
                      prop="gjw"
                      min-width="250px"
                      :show-overflow-tooltip="true"
                    />
                    <template slot="empty">
                      <div class="nodata">
                        <img src="@/img/nodata.png" alt="" width="160" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="`${year}年院内课题成果评分表`"
              name="2"
              v-if="user.bmbh == '0130'"
            >
              <el-table
                :max-height="400"
                :data="tab1TableYnpf"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
                v-if="tab1Active1 == 1"
              >
                <el-table-column
                  label="课题编号"
                  align="left"
                  prop="courseId"
                  min-width="80px"
                  :show-overflow-tooltip="true"
                  sortable
                />
                <el-table-column
                  label="课题名称"
                  align="left"
                  prop="courseName"
                  min-width="150px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="项目类型"
                  align="left"
                  prop="courseType"
                  min-width="100px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="课题负责人"
                  align="left"
                  prop="courseLeaderName"
                  min-width="80px"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="课题评分"
                  align="left"
                  prop="score"
                  min-width="80px"
                  :show-overflow-tooltip="true"
                  sortable
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <div class="tab1_more" @click="handleClickActive1">查看更多</div>
        </div>
        <div class="left_card_bottom">
          <div class="card2">
            <div class="card_title">
              <span>最新课题追踪月报反馈情况</span>
              <div class="tab1_more" @click="handleToTrackResult()">
                查看更多
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
            <div class="tab_wrap">
              <el-tabs v-model="active2">
                <el-tab-pane label="研究课题" name="1">
                  <div>
                    <el-table
                      max-height="350"
                      :data="tab2TableYJ"
                      fit
                      highlight-current-row
                      :default-sort="{ prop: 'date', order: 'descending' }"
                      tooltip-effect="dark"
                    >
                      <el-table-column
                        label="课题编号"
                        align="left"
                        prop="courseId"
                        sortable
                        min-width="110px"
                        :show-overflow-tooltip="true"
                      />
                      <el-table-column
                        label="课题主题"
                        align="left"
                        prop="courseName"
                        min-width="130px"
                        :show-overflow-tooltip="true"
                      />
                      <el-table-column
                        label="拟结项评审时间"
                        align="left"
                        prop="solveTime"
                        min-width="120px"
                        :show-overflow-tooltip="true"
                      />
                      <el-table-column
                        label="风险预警等级"
                        align="center"
                        prop="riskWarning"
                        sortable
                        min-width="130px"
                        :show-overflow-tooltip="true"
                      >
                        <template slot-scope="scope">
                          <span
                            :class="
                              scope.row.riskWarning == '高风险'
                                ? 'red_label'
                                : scope.row.riskWarning == '中风险'
                                ? 'yellow_label'
                                : 'green_label'
                            "
                            >{{ scope.row.riskWarning }}</span
                          >
                        </template>
                      </el-table-column>
                      <template slot="empty">
                        <div class="nodata">
                          <img src="@/img/nodata.png" alt="" width="160" />
                          <div>暂无数据</div>
                        </div>
                      </template>
                    </el-table>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="技术课题" name="2">
                  <el-table
                    :max-height="400"
                    :data="tab2TableJs"
                    fit
                    highlight-current-row
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    tooltip-effect="dark"
                  >
                    <el-table-column
                      label="课题编号"
                      align="left"
                      prop="courseid"
                      sortable
                      min-width="110px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题主题"
                      align="left"
                      prop="coursename"
                      min-width="130px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="拟结项评审时间"
                      align="left"
                      prop="closingitemapplytime"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="风险预警等级"
                      align="left"
                      prop="riskwarning"
                      sortable
                      min-width="130px"
                      :show-overflow-tooltip="true"
                    />
                    <template slot="empty">
                      <div class="nodata">
                        <img src="@/img/nodata.png" alt="" width="160" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="card3">
            <div class="card_title">
              <span>{{ year }}课题所在部门占比</span>
              <span>
                <el-select
                  v-model="card3Active"
                  placeholder="请选择"
                  style="width: 120px"
                  size="mini"
                  @change="handleChangeCard3"
                >
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="研究课题" value="1"></el-option>
                  <el-option label="技术课题" value="2"></el-option>
                </el-select>
              </span>
            </div>
            <div id="card_chart"></div>
          </div>
        </div>
      </div>
      <div class="container_right">
        <div class="card4">
          <div>
            <div class="card_title">{{ year }}年课题概况</div>
            <el-tabs
              v-model="active3"
              type="card"
              @tab-click="handleChangeCard4"
            >
              <el-tab-pane
                :label="item.dictLabel"
                :name="item.dictValue"
                v-for="item in ktsxOptions"
                :key="item.dictValue"
              ></el-tab-pane>
            </el-tabs>
            <div class="course_count">
              <div v-for="(item, index) in ktgkData" :key="index">
                <div>{{ item.name }}</div>
                <div @click="handleToList(item)">{{ item.wcytotal }}</div>
              </div>
            </div>

            <div
              class="jxsq_btn"
              v-if="active3 != '0' && currentStep.currentstepname"
              @click="handleClickActiveBtn"
            >
              {{ currentStep.currentstepname }}
            </div>
          </div>
        </div>
        <div class="card5">
          <div>
            <div class="card_title">优秀成果</div>
            <div class="card_wrap">
              <el-tabs
                v-model="tab5Params.group"
                @tab-click="handleChangeCard5"
              >
                <el-tab-pane label="研究课题" name="1">
                  <el-table
                    :max-height="340"
                    :data="tab5TableYJ"
                    fit
                    highlight-current-row
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    tooltip-effect="dark"
                  >
                    <el-table-column
                      label="奖项"
                      align="left"
                      prop="prize"
                      min-width="80px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题编号"
                      align="left"
                      prop="courseid"
                      min-width="110px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题主题"
                      align="left"
                      prop="coursename"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <div>
                          <el-button
                            type="text"
                            @click="handleViewCgw(scope.row)"
                            >{{ scope.row.coursename }}</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="课题负责人"
                      align="left"
                      prop="courseleader"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题主要成员"
                      align="left"
                      prop="membername"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题所在部门"
                      align="left"
                      prop="memberbmmc"
                      min-width="110px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="奖金报销(元)"
                      align="left"
                      prop="money_award"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <template slot="empty">
                      <div class="nodata">
                        <img src="@/img/nodata.png" alt="" width="160" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="技术课题" name="2">
                  <el-table
                    :max-height="340"
                    :data="tab5TableJs"
                    fit
                    highlight-current-row
                    :default-sort="{ prop: 'date', order: 'descending' }"
                    tooltip-effect="dark"
                  >
                    <el-table-column
                      label="奖项"
                      align="left"
                      prop="prize"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题编号"
                      align="left"
                      prop="courseid"
                      min-width="100px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题主题"
                      align="left"
                      prop="coursename"
                      min-width="150px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题负责人"
                      align="left"
                      prop="courseleader"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题主要成员"
                      align="left"
                      prop="membername"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="课题所在部门"
                      align="left"
                      prop="memberbmmc"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <el-table-column
                      label="奖金报销(元)"
                      align="left"
                      prop="money_award"
                      min-width="120px"
                      :show-overflow-tooltip="true"
                    />
                    <template slot="empty">
                      <div class="nodata">
                        <img src="@/img/nodata.png" alt="" width="160" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </el-table>
                </el-tab-pane>
              </el-tabs>

              <div class="card5_select_year">
                <el-date-picker
                  v-model="tab5Params.year"
                  type="year"
                  :picker-options="pickerOptions"
                  placeholder="选择年"
                  size="mini"
                  @change="handleChangeCard5Year"
                ></el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课题录入 -->
    <el-dialog
      title="课题录入"
      :visible.sync="addCourseDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="addCourseDialog"
    >
      <AddCourse :mxParams="mxParams" ref="addCourseForm"></AddCourse>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCourseDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveAddCourseForm">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 成果物 -->
    <el-dialog
      :title="cgwTitle"
      :visible.sync="cgwDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="cgwDialog"
    >
      <CgwView
        :mxParams="mxParams"
        ref="cgwView"
        @getParentData="fetchExcellentCgList(tab5Params)"
      ></CgwView>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cgwDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as echarts from "echarts";
import moment from "moment";
import { mapGetters } from "vuex";
import CgwView from "./courseFile/cgwView";
import AddCourse from "./courseList/courseForm/addCourse.vue";

import {
  getCourseBasic,
  getDeptChart,
  getExcellentCgList,
  getFeedbackList,
  getResultScoreList,
  getStudyTimeList,
} from "@/api/course.js";
import { getDictData } from "@/api/task.js";

export default {
  name: "course",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: {
    AddCourse,
    CgwView,
  },
  data() {
    return {
      addCourseDialog: false,
      cgwDialog: false,
      active1: "1",
      tab1Active1: 1,
      tab1TableYJ: [],
      tab1TableJs: [],
      tab1TableYnpf: [],
      active2: "1",
      tab2TableYJ: [],
      tab2TableJs: [],
      charData: [],
      card3Active: "0",
      ktgkData: [],
      currentStep: {
        currentstepname: "",
      },
      tab5TableYJ: [],
      tab5TableJs: [],
      tab5Params: {
        group: "1",
        page: 1,
        pageSize: 100,
        year: moment().subtract(1, "year").format("YYYY"),
      },
      active3: "0",
      active4: "1",
      active5: "1",
      active6: "1",
      year: null,
      ktsxOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() - 24 * 60 * 60 * 1000 ||
            time.getTime() < moment("2019").startOf("day").format("x")
          );
        },
      },
      mxParams: {},
      cgwTitle: null,
    };
  },
  created() {
    // if (!this.user.xm) {
    this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
      if (res.code == 0) {
        this.year = this.user.year;
        this.getAll();
      }
    });
    // } else {
    //   this.year = this.user.year;
    //   this.getAll();
    // }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.drawCharts("card_chart", this.charData, true);
    });
  },
  methods: {
    getAll() {
      const year = this.year;
      getDictData("pmp_course_group", 1).then((res) => {
        if (res.code === 0) {
          this.ktsxOptions = [
            { dictLabel: "全部课题", dictValue: "" },
            ...res.data,
          ];
        }
      });
      getStudyTimeList({ year, page: 1, pageSize: 100, group: 1 }).then(
        (res) => {
          if (res.code == 0) {
            this.tab1TableYJ = res.data;
          }
        }
      );
      getStudyTimeList({ year, page: 1, pageSize: 100, group: 2 }).then(
        (res) => {
          if (res.code == 0) {
            this.tab1TableJs = res.data;
          }
        }
      );
      getResultScoreList({ year, page: 1, pageSize: 7, courseName: "" }).then(
        (res) => {
          if (res.code == 0) {
            this.tab1TableYnpf = res.data;
          }
        }
      );
      getFeedbackList({
        year,
        page: 1,
        pageSize: 7,
        courseName: "",
        group: 1,
      }).then((res) => {
        if (res.code == 0) {
          this.tab2TableYJ = res.data;
        }
      });
      getFeedbackList({
        year,
        page: 1,
        pageSize: 7,
        courseName: "",
        group: 2,
      }).then((res) => {
        if (res.code == 0) {
          this.tab2TableJs = res.data;
        }
      });
      this.fetchDeptChart(0, year);
      this.fetchCourseBasic(0);
      this.fetchExcellentCgList(this.tab5Params);
    },
    drawCharts(id, data, isResize) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(id));
      if (isResize) {
        myChart.resize();
        return;
      }
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: (item) => {
            return `${item.data.key}:${item.data.value} (${item.percent}%)`;
          },
        },

        label: {
          position: "outer",
          alignTo: "labelLine",
          bleedMargin: 30,
          lineHeight: 15,
          fontSize: 12,
          formatter: (item) => {
            return `${item.data.key}:${item.data.value}`;
          },
        },
        labelLine: {},
        series: [
          {
            name: "部门",
            type: "pie",
            radius: ["20%", "40%"],
            emphasis: {
              label: {
                // show: false,
                fontSize: "14",
                fontWeight: "bold",
              },
            },
            itemStyle: {
              normal: {
                label: { show: true },
                labelLine: { show: true },
                // color: function (params) {
                //   return colorList[params.dataIndex];
                // },
              },
            },
            data,
          },
        ],
      });
    },
    fetchDeptChart(group, year) {
      getDeptChart({ group, year }).then((res) => {
        if (res.code == 0) {
          this.drawCharts("card_chart", res.data);
          this.charData = res.data;
        }
      });
    },
    fetchCourseBasic(group) {
      getCourseBasic({ group }).then((res) => {
        if (res.code == 0) {
          this.ktgkData = res.data.courseBasic;
          if (res.data.stepDetail) {
            this.currentStep = res.data.stepDetail;
          } else {
            this.currentStep = [];
          }
        }
      });
    },
    fetchExcellentCgList(params) {
      getExcellentCgList(params).then((res) => {
        if (res.code == 0) {
          if (params.group == 1) {
            this.tab5TableYJ = res.data;
            this.tab5TableJs = [];
          } else {
            this.tab5TableJs = res.data;
            this.tab5TableYJ = [];
          }
          if (this.cgwDialog) {
            this.$nextTick(() => {
              this.$refs.cgwView.initData();
            });
          }
        }
      });
    },
    handleChangeCard3(e) {
      this.fetchDeptChart(e, this.year);
    },
    handleChangeCard4(e) {
      this.fetchCourseBasic(e.name);
    },
    handleChangeCard5() {
      if (this.tab5Params.group == 1) {
        // this.tab5Params.prize = "特等奖";
      } else {
        // this.tab5Params.prize = "金葵奖";
      }
      this.fetchExcellentCgList(this.tab5Params);
    },
    handleChangeCard5Child() {
      this.fetchExcellentCgList(this.tab5Params);
    },
    handleChangeCard5Year() {
      this.tab5Params.year = moment(this.tab5Params.year).format("YYYY");
      this.fetchExcellentCgList(this.tab5Params);
    },
    handleToList(item) {
      const ktsx = this.active3 == "0" ? null : this.active3;
      const year = this.year;
      if (item.name == "课题总数") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, nf: year },
        });
      } else if (item.name == "通过立项评审") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, sflx: "1", nf: year },
        });
      } else if (item.name == "待我评审课题") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, type: "1", nf: year },
        });
      } else if (item.name == "我辅导课题") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, type: "4", nf: year },
        });
      } else if (item.name == "通过结项评审") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, sfjx: "1", nf: year },
        });
      } else if (item.name == "我参与课题") {
        this.$router.push({
          name: "courseList",
          params: { ktsx, type: "3", nf: year },
        });
      }
    },
    handleClickActive1() {
      if (this.active1 == 1) {
        this.$router.push({
          name: "courseArrange",
          params: { ktsx: this.tab1Active1 },
        });
      } else {
        this.$router.push({ path: "/course/ktcgpfResult" });
      }
    },
    handleClickActiveBtn() {
      const ktsx = this.active3 == "0" ? null : this.active3;
      if (
        this.currentStep.currentstep == 0 ||
        this.currentStep.currentstep == 1
      ) {
        this.addCourseDialog = true;
        this.mxParams.isIndex = 1;
        this.mxParams.courseGroup = this.active3;
      } else if (
        this.currentStep.currentstep == 2 ||
        this.currentStep.currentstep == 5 ||
        this.currentStep.currentstep == 14
      ) {
        this.$router.push({
          name: "courseList",
          params: { ktsx, type: "3" },
        });
      } else if (
        this.currentStep.currentstep == 3 ||
        this.currentStep.currentstep == 6 ||
        this.currentStep.currentstep == 13 ||
        this.currentStep.currentstep == 15 ||
        this.currentStep.currentstep == 4
      ) {
        this.$router.push({
          name: "courseList",
          params: { ktsx, type: "1" },
        });
      } else if (this.currentStep.currentstep == 11) {
        this.$router.push({
          name: "trackResult",
          params: { courseGroup: ktsx },
        });
      } else if (this.currentStep.currentstep == 7) {
        this.$router.push({
          name: "courseList",
          params: { ktsx },
        });
      } else {
        this.$router.push({
          name: "courseList",
          params: { ktsx },
        });
      }
    },
    saveAddCourseForm() {
      this.$refs.addCourseForm.saveForm();
    },
    handleToTrackResult() {
      this.$router.push({
        name: "trackResult",
        params: { courseGroup: this.active2 },
      });
    },
    handleViewCgw(row) {
      this.cgwTitle = row.file_name;
      this.cgwDialog = true;
      this.mxParams = row;
      // window.open(url);
    },
  },
};
</script>
<style lang='less' scoped>
.course_index {
  min-height: 100%;
  background-color: #f2f2f2;
}
.header {
  background-color: #2f4050;
  height: 60px;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  > div:nth-of-type(1) {
    img {
      cursor: pointer;
    }
  }
  > div:nth-of-type(2) {
    display: flex;
    img {
      height: 20px;
      margin-top: 10px;
      margin-right: 10px;
    }
    div {
      margin-right: 15px;
      display: flex;
    }
    div:nth-of-type(2) {
      cursor: pointer;
    }
  }
}
.container {
  display: flex;
  .container_left {
    width: 60%;
    .card1 {
      position: relative;
      margin: 15px;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
      padding: 15px;
      box-sizing: border-box;
      height: 470px;
      background-color: #fff;
      margin-bottom: 0;
      .tab1_active1 {
        display: flex;
        width: 100%;
        .tab1_active1_left {
          padding: 15px;
          width: 180px;
          > div {
            width: 150px;
            height: 100px;
            cursor: pointer;
            border: 1px solid #dcdcdc;
            font-size: 16px;
            text-align: center;
            line-height: 100px;
            box-sizing: border-box;
          }
          > div:nth-of-type(1) {
            border-radius: 5px 5px 0 0;
            border-bottom: 0;
          }
          > div:nth-of-type(2) {
            border-radius: 0 0 5px 5px;
            border-top: 0;
          }
          .tab1_active1_div {
            background-color: #8080ff;
            color: #fff;
            border: 0;
          }
        }
        .tab1_active1_right {
          overflow: auto;
          width: calc(100% - 180px);
        }
      }
    }
    .tab1_more {
      position: absolute;
      height: 25px;
      right: 15px;
      top: 30px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
    }
    .left_card_bottom {
      width: 100%;
      display: flex;
      .card2 {
        position: relative;
        margin: 15px 0 15px 15px;
        border: 1px solid #dcdcdc;
        border-radius: 5px;
        padding: 15px;
        box-sizing: border-box;
        height: 470px;
        width: calc(50% - 20px);
        background-color: #fff;
        .card_title {
          display: flex;
          justify-content: space-between;
          span:nth-of-type(1) {
            color: #000;
            font-weight: 700;
            font-size: 16px;
          }
          span:nth-of-type(2) {
            color: #666;
            line-height: 16px;
            cursor: pointer;
            font-size: 14px;
          }
        }
        .tab_wrap {
          margin-top: 15px;
        }
      }
      .card3 {
        position: relative;
        margin: 15px;
        border: 1px solid #dcdcdc;
        border-radius: 5px;
        padding: 15px;
        box-sizing: border-box;
        height: 470px;
        width: 50%;
        background-color: #fff;
        .card_title {
          display: flex;
          justify-content: space-between;
          > span:nth-of-type(1) {
            color: #000;
            font-weight: 700;
            font-size: 16px;
          }
          .el-dropdown-link {
            color: #036eb8;
            line-height: 16px;
            cursor: pointer;
          }
        }
        #card_chart {
          height: calc(100% - 30px);
          z-index: 10;
        }
      }
    }
  }
  .container_right {
    width: 40%;
    .card4 {
      position: relative;
      margin: 15px 15px 15px 0;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
      padding: 15px;
      box-sizing: border-box;
      height: 470px;
      background-color: #fff;
      .card_title {
        display: flex;
        justify-content: space-between;
        color: #000;
        font-weight: 700;
        font-size: 16px;
        line-height: 40px;
      }
      .course_count {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        > div {
          width: 33%;
          text-align: center;
          color: #666;
          font-size: 16px;
          line-height: 44px;
          margin-top: 15px;
          > div:nth-of-type(2) {
            color: #1ea3a5;
            font-size: 28px;
            cursor: pointer;
            display: inline;
          }
        }
      }
      .jxsq_btn {
        width: 50%;
        height: 44px;
        line-height: 44px;
        background-color: #2285cc;
        color: #fff;
        border-radius: 22px;
        text-align: center;
        font-size: 16px;
        margin: 0 auto;
        margin-top: 45px;
        cursor: pointer;
      }
    }
    .card5 {
      position: relative;
      margin: 15px 15px 15px 0;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
      padding: 15px;
      box-sizing: border-box;
      height: 470px;
      background-color: #fff;
      .card_title {
        display: flex;
        justify-content: space-between;
        color: #000;
        font-weight: 700;
        font-size: 16px;
        line-height: 40px;
      }
      .card_wrap {
        position: relative;
        .card5_select_year {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
  }
}
.red_label {
  color: #fff;
  height: 28px;
  background-color: #ff0000;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.yellow_label {
  color: #999;
  height: 28px;
  background-color: #ffff80;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
.green_label {
  color: #fff;
  height: 28px;
  background-color: #4b7902;
  text-align: center;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 28px;
  border-radius: 3px;
}
</style>